(function ($) {

    var $resourceSlider;


    this.init = function () {

        $resourceSlider = $(".lifeevents-content-slider");

        $(".lifeevents-content-slider-slide-link").hover(function () {
            $(this).addClass("pulse");
        }, function () {
            $(this).removeClass("pulse");
        });

        this.ResourcesSlider();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.ResourcesSlider = function () {

        BuildResourcesSlider();

        function BuildResourcesSlider() {
            $resourceSlider.slick({
                dots: false,
                focusOnSelect: true,
                centerPadding: 0,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" tabindex="0" role="button" aria-controls="LifeEventsSlider"><i class="fas fa-chevron-left"></i><span class="sr-only">Show Previous Items</span></button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" tabindex="0" role="button" aria-controls="LifeEventsSlider"><i class="fas fa-chevron-right"></i><span class="sr-only">Show Next Items</span></button>',
                appendArrows: $(".lifeevents-content-arrows"),
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            });

            resetArrows();

            $resourceSlider.on("afterChange", function () {
                // if we're at one end of the other, let's make the arrows unfocusable
                resetArrows();
            });
        }
        function resetArrows() {
            $(".slick-prev, .slick-next").each(function () {
                if ($(this).hasClass("slick-disabled")) {
                    $(this).attr("tabindex", -1);
                } else {
                    $(this).removeAttr("tabindex");
                }
            });
        }
    }

    this.init();

})(jQuery);